<form [formGroup]="form" fxLayout="column" fxLayoutAlign="start" fxFlex="1 0 auto" name="form">

  <div class="mb-24" fxLayout="column" fxLayoutAlign="start">
    <div fxLayout="row" fxLayout.sm="row" fxLayout.xs="column" fxLayoutAlign="space-around stretch"
      fxLayoutAlign.sm="space-around stretch" fxLayoutAlign.xs="space-around stretch">
      <mat-form-field appearance="outline" style="width: 100%">
        <mat-label>Motivo de cancelación de la actuación</mat-label>
        <textarea matInput formControlName="motivo" rows="7"
          placeholder="Agrega el motivo de la cancelación de la actuación" maxlength="40000"></textarea>
      </mat-form-field>
    </div>
  </div>

</form>